import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step3 } from '../../../../shared/models/component-messages/mapaIN/step3';
import { TypeOuiNon } from '../models/TypeOuiNon';
@Component({
  selector: 'app-type-oui-non',
  templateUrl: './type-oui-non.component.html'
})
export class TypeOuiNonComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeOuiNon';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;

	@Input() typeOuiNon: TypeOuiNon;
  @Input() labelRadio: String;

    public step3 = new Step3();

    radioButtonValue;
    radioButtonCtrlName;


  constructor() { }

  public ngOnInit() {
    if (this.typeOuiNon.oui){
      this.radioButtonValue = 'Oui';
    } else if(this.typeOuiNon.oui === null && this.typeOuiNon.non === null){
      this.radioButtonValue = null;
    } else {
      this.radioButtonValue = 'Non';
    }

    this.radioButtonCtrlName = this.getUid() + '_SepAtt_oui';
  }








  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }


}

